var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6267_8895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4932 3.1635C7.2619 -1.412 0.610422 2.60816 0.501353 8.05814C0.473558 9.44708 0.874496 10.8 1.67258 12.0473H6.84549L7.76558 10.5138C8.03275 10.0685 8.67929 10.0542 8.9616 10.4981L10.9029 13.5486L13.7326 7.5748C13.9794 7.05354 14.7149 7.037 14.9871 7.54246L17.4128 12.0473H23.3138C27.6851 5.21534 19.0459 -2.56771 12.4932 3.1635Z",
    fill: "#0B1526"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3737 13.084L14.4081 9.43359L11.6286 15.3014C11.3921 15.8007 10.6966 15.844 10.4 15.3779L8.38594 12.213L7.84631 13.1124C7.71924 13.3242 7.49042 13.4537 7.24345 13.4537H2.78467C2.92444 13.6 2.17951 12.8566 11.9972 22.6234C12.2714 22.8962 12.7146 22.8962 12.9889 22.6234C22.6554 13.0068 22.0619 13.5997 22.2013 13.4537H16.9927C16.734 13.4538 16.4963 13.3117 16.3737 13.084Z",
    fill: "#0B1526"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6267_8895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.76d6923c645a6d2b01622a5480c39818.svg";
export { ForwardRef as ReactComponent };